/**
 * Created by mykurisu on 2017/8/8.
 */
import React from 'react'
import {Link} from 'react-router'
import {connect} from 'react-redux'
import '../../styles/search/SearchPage.css'

class SearchTitleBar extends React.Component {

    renderLink() {
        const {name} = this.props;
        if (name === '直播间') {
            return '/search/liveroom/detail'
        } else if (name === '专栏') {
            return '/search/channel/detail'
        }
    }

    render() {
        const {name, hasMore, search} = this.props;
        return (
            <div>
                {(name === '直播间' || name === '专栏') &&
                <Link to={{pathname: this.renderLink(), query: {q: search.search_text}}}>
                    <div className="search-page-titlebar">
                        <span className="search-page-titlebar-title">
                            <div className="search-page-titlebar-row"></div>
                            {name}
                        </span>
                        {hasMore && name === '直播间' &&
                        <span className="search-page-titlebar-link">查看更多</span>
                        }
                        {hasMore && name === '专栏' &&
                        <span className="search-page-titlebar-link">查看更多</span>
                        }
                    </div>
                </Link>
                }
                {(name !== '直播间' && name !== '专栏') &&
                <div className="search-page-titlebar">
                    <span className="search-page-titlebar-title">
                        <div className="search-page-titlebar-row"></div>
                        {name}
                    </span>
                </div>
                }
            </div>
        )
    }
}

export default connect(state => ({
    search: state.search,
}))(SearchTitleBar)


// WEBPACK FOOTER //
// ./src/components/search/SearchTitleBar.js